// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"textformat-bold"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M6 12H13C15.2091 12 17 10.2091 17 8C17 5.79086 15.2091 4 13 4H6V12ZM6 12H14C16.2091 12 18 13.7909 18 16C18 18.2091 16.2091 20 14 20H6V12Z","strokeWidth":"props.strokeWidth"}}]}]};

const TextformatBoldIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'textformat-bold',
    ref,
    icon: element,
  },
));

TextformatBoldIcon.displayName = 'TextformatBoldIcon';

export default TextformatBoldIcon;
